// extracted by mini-css-extract-plugin
export default {"rating":"hy-z","numberOfStars":"iy-z","count":"jy-z","barGraphSpacing":"ky-z","barGraph":"ly-z"};